import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cao',
  templateUrl: './cao.component.html',
  styleUrls: ['./cao.component.scss']
})
export class CaoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
